import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaTimes } from 'react-icons/fa';
import './ContactForm.css';

const ContactForm = ({ onSubmit, onSkip }) => {
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhone = (phone) => {
    const cleaned = phone.replace(/[\s\-\(\)]/g, '');
    return /^\d{10,15}$/.test(cleaned);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!phone && !email) {
      setError('Please provide at least one contact method');
      return;
    }

    if (phone && !validatePhone(phone)) {
      setError('Please enter a valid phone number (10-15 digits)');
      return;
    }

    if (email && !validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(phone, email);
    } catch (err) {
      setError('Failed to save contact information. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-form-overlay">
      <div className="contact-form">
        <div className="contact-form-header">
          <h3>
            <span className="header-icon">📞</span>
            Contact Information
          </h3>
          <p>The property manager will reach out with an answer to your question</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="contact-form-inputs">
            <div className="input-group">
              <label htmlFor="phone">
                <FaPhone className="input-icon" />
                Phone Number (Optional)
              </label>
              <input
                id="phone"
                type="tel"
                placeholder="+1 (234) 567-8900"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="contact-input"
                disabled={isSubmitting}
              />
            </div>

            <div className="input-group">
              <label htmlFor="email">
                <FaEnvelope className="input-icon" />
                Email Address (Optional)
              </label>
              <input
                id="email"
                type="email"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="contact-input"
                disabled={isSubmitting}
              />
            </div>
          </div>

          {error && (
            <div className="contact-error">
              <FaTimes className="error-icon" />
              {error}
            </div>
          )}

          <div className="contact-form-actions">
            <button 
              type="submit" 
              className="btn-primary"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span className="spinner-small"></span>
                  Submitting...
                </>
              ) : (
                <>✅ Submit Contact Info</>
              )}
            </button>
            <button 
              type="button"
              onClick={onSkip} 
              className="btn-secondary"
              disabled={isSubmitting}
            >
              ⏭️ Skip for Now
            </button>
          </div>
        </form>

        <p className="contact-form-note">
          💡 Providing your contact info helps us assist you better
        </p>
      </div>
    </div>
  );
};

export default ContactForm;